// extracted by mini-css-extract-plugin
export default {"CFPHeader":"CFPHeader_CFPHeader__35cMs","active":"CFPHeader_active__pFoBz"};